var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export function DPTransactionMapper(data) {
    var dpTransactions = new Array();
    var dpTransactionEntity = {
        dpTranactions: [],
    };
    if (data) {
        data.reduce(function (acc, record) {
            dpTransactions.push(__assign(__assign({}, record), { accountCode: record.accCode }));
            return acc;
        }, []);
        dpTransactionEntity.dpTranactions = dpTransactions;
        return dpTransactionEntity;
    }
    else {
        return null;
    }
}
export function DPIdsMapper(data) {
    var dpIds = new Array();
    var dpTransactionEntity = {
        dpIds: [],
    };
    if (data) {
        data.reduce(function (acc, record) {
            dpIds.push({ value: record.boId, display: record.boId });
            return acc;
        }, []);
        dpTransactionEntity.dpIds = dpIds;
        return dpTransactionEntity;
    }
    else {
        return null;
    }
}
